export default __webpack_public_path__ + "static/media/tara-bot.c523a031.svg";